import Vue from 'vue'
import Vuex from 'vuex'
import signin from './modules/auth/signin'
import signout from './modules/auth/signout'
import signup from './modules/auth/signup'
import market from './modules/general/market'
import home from './modules/general/home'
import cart from './modules/general/cart'
import filter from './modules/general/filter'
import customer from './modules/member/customer'
import relationships from './modules/user/relationships'
import reviews from './modules/user/reviews'
import account from './modules/user/account'
import cards from './modules/user/cards'
import alerts from './modules/user/alerts'
import promotions from './modules/user/promotions'
import location from './modules/user/location'
import anewitem from './modules/user/anewitem'
import messages from './modules/user/messages'
import payouts from './modules/user/payouts'
import portal from './modules/user/portal'
import access from './modules/shop/access'
import business from './modules/shop/business'
import sales from './modules/shop/sales'
import categories from './modules/portal/categories'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		signin,
		signout,
		signup,
		account,
		cards,
		alerts,
		location,
		anewitem,
		market,
		home,
		cart,
		filter,
		customer,
		messages,
		payouts,
		portal,
		access,
		sales,
		business,
		reviews,
		categories,
		promotions,
		relationships
	}
})
